import axios from '@/axios';
import { AxiosInstance } from 'axios';
import {
  TVulnerabilityDetails,
  TFetchVulnerabilityPayload,
  TDownloadVulnerabilityImagePayload,
  TDownloadVulnerabilityImageResponse,
  TCreateFolderPayload,
  TCreateFolderResponse,
  TMoveVulnerabilityToFolderPayload,
} from '../models/types';

const axiosInstance = axios as AxiosInstance;

export async function fetchVulnerability(payload: TFetchVulnerabilityPayload) {
  const response = await axiosInstance.get<TVulnerabilityDetails>(
    `/private/ui/vulnerabilities/${payload.uid}`
  );

  return response.data;
}

export async function createFolder(payload: TCreateFolderPayload) {
  const isSingleScan = 'jobId' in payload;

  const response = await axiosInstance.post<TCreateFolderResponse>(
    '/private/ui/folders',
    {
      name: payload.name,
    },
    {
      params: isSingleScan ? { jobId: payload.jobId } : { integrationId: payload.integrationId },
    }
  );

  return response.data;
}

export async function moveVulnerabilityToFolder(payload: TMoveVulnerabilityToFolderPayload) {
  const response = await axiosInstance.post('/private/ui/folders_data/update', payload);

  return response.data;
}

export async function downloadVulnerabilityImage(payload: TDownloadVulnerabilityImagePayload) {
  const query = `vulnerabilityId=${payload.vulnerabilityId}${
    payload.categoryId ? `&categoryId=${payload.categoryId}` : ''
  }`;

  let url: string;
  if (payload.type === 'single-scan') {
    url = `/private/ui/vulnerability_image/${payload.jobId}/report?${query}`;
  } else {
    url = `/private/ui/vulnerability_image/integrations/${payload.integrationId}/branches/${payload.branchName}/versions/${payload.versionId}/report?${query}`;
  }

  const response = await axiosInstance.post<TDownloadVulnerabilityImageResponse>(url);
  return response.data;
}
